module.exports = __webpack_public_path__ + "img/3.eb60dc31.jpg";